/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class DelCustomerShortVO extends JSONable {
  uuid: string | null = null;
  legalEntityUuid: string | null = null;
  businessProfileUuid: string | undefined = undefined;
  companyName: string | null = null;
  industryType: string | undefined = undefined;
  country: string | undefined = undefined;
  uniqueIdentificationNumber: string | undefined = undefined;
  platformMember: boolean | undefined = undefined;
}
